/*
 * サブシステム名：マスタ管理
 * 機能名：権限設定
 */
import DdFooterButton from '@/components/DdFooterButton'

import message from '@/ddv2.library/messages'

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'

const DdDropDown = () => import('@/components/DdDropDown')
const DdArrowHeader = () => import('@/components/DdArrowHeader')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox')

export default {
  name: 'MstKengenEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {
      mstKengenGroupTable: {
        kengenGroupCd: '',
        kengenGroupNm: ''
      },
      inputKengenKbn: {}
    },
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false
  }),
  components: {
    DdDropDown,
    DdFooterButton,
    DdArrowHeader,
    DdSubHeader,
    DdTextBox,
    DdNumericBox
  },
  computed: {
    ...mapGetters({
      menuList: 'DDMasters/msysMenu',
      menuDetailList: 'DDMasters/msysMenuDetail',
      kinoList: 'DDMasters/msysKino',
      kubunList: 'DDMasters/msysKubun'
    }),
    filteredKengenKubun () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF027'
      }).map(function (elem) {
        elem.value = elem.code.trim()
        elem.text = elem.codeNm
        return elem
      })
    },
    filteredMenuList () {
      const result = this.menuList.map((m) => {
        m.listDisplay = this.menuDetailList.filter((d) => {
          return d.mstMenuId === m.id
        }).map((d) => {
          const kino = this.kinoList.find((k) => {
            return d.mstKinoId === k.id
          })
          d.kinoNm = kino.kinoNm
          d.viewNm = kino.viewNm
          return d
        }).sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
        return m
      })
        .sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
      return result
    },
    isDeleteDisable () {
      return this.id === 0
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        self.HttpClient
          .post(`/api/v1/mstKengenGroup/searchChildren?id=${self.id}`)
          .then((data) => {
            self.rec.mstKengenGroupTable = data.payload.mstKengenGroupTable
            self.rec.mstKengen = data.payload.mstKengen
            if (data.payload.mstKengen.length !== 0) {
              for (var i of data.payload.mstKengen) {
                self.rec.inputKengenKbn['key_' + i.mstMenuDetailId] = i.kengenKbn
              }
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msysmenudetail', 'msyskino', 'msyskubun'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              mstKengenGroupTable: {
                hyojiOrder: 9999
              },
              mstKengen: [],
              inputKengenKbn: {}
            }
            for (var i in self.filteredMenuList) {
              for (var _i in self.filteredMenuList[i].listDisplay) {
                self.rec.inputKengenKbn['key_' + self.filteredMenuList[i].listDisplay[_i].id] = '00'
              }
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      // 初回キャンセル時にDDdropdown項目のみを変更した場合、なぜか表示が変更されないため、その対応
      this.rec = Object.assign({}, this.rec)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(`/api/v1/mstKengenGroup/deleteMulti?id=${self.id}&tm=${self.rec.timestamp}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.mstKengenGroupTable.id = 0
          self.modeOfEdit = 0
          // クローンデータ上書き（キャンセル実行時に権限グループが複写元のデータのIDに上書かれるのを防ぐ）
          self.cloneData = JSON.parse(JSON.stringify(self.rec))
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            // payloadにidを直接設定している
            self.id = data.payload
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      var wkRow = {}
      var wkList = []
      var i
      if (this.id === 0) {
        // 入力項目の値をもとに更新データを作成
        for (i in this.rec.inputKengenKbn) {
          wkRow = {}
          wkRow.id = -1
          wkRow.mstMenuDetailId = i.replace('key_', '')
          wkRow.kengenKbn = this.rec.inputKengenKbn[i]
          wkList.push(wkRow)
        }
        this.rec.mstKengen = wkList
        f = this.HttpClient.post('/api/v1/mstKengenGroup/createMulti', this.rec)
      } else {
        // 入力項目の値を取得したデータに反映
        this.rec.mstKengen = this.rec.mstKengen.map((elem) => {
          elem.kengenKbn = this.rec.inputKengenKbn['key_' + elem.mstMenuDetailId]
          return elem
        })
        // 新規作成分の更新データを作成
        for (i in this.rec.inputKengenKbn) {
          if (this.rec.mstKengen.some((elem) => { return elem.mstMenuDetailId.toString() === i.replace('key_', '') }) === false) {
            wkRow = {}
            wkRow.id = -1
            wkRow.mstMenuDetailId = i.replace('key_', '')
            wkRow.kengenKbn = this.rec.inputKengenKbn[i]
            wkList.push(wkRow)
          }
        }
        this.rec.mstKengen = this.rec.mstKengen.concat(wkList)

        f = this.HttpClient.put(`/api/v1/mstKengenGroup/updateMulti?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      if (this.id !== 0 && this.cloneData.mstKengenGroupTable.kengenGroupCd !== this.rec.mstKengenGroupTable.kengenGroupCd) {
        this.$refs.kengenGroupCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['権限グループコード']))
        this.setInvalidSummaryMessage('COME0015')
        this.rec.mstKengenGroupTable.kengenGroupCd = this.cloneData.mstKengenGroupTable.kengenGroupCd
        return false
      }
      return true
    },
    deleteValidate: function () {
      if (this.cloneData.mstKengenGroupTable.kengenGroupCd !== this.rec.mstKengenGroupTable.kengenGroupCd) {
        this.$refs.kengenGroupCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['権限グループコード']))
        this.setInvalidSummaryMessage('COME0015')
        this.rec.mstKengenGroupTable.kengenGroupCd = this.cloneData.mstKengenGroupTable.kengenGroupCd
        return false
      }
      return true
    }
  }
}
